import { render, staticRenderFns } from "./PolicyDetail.vue?vue&type=template&id=271355f4&scoped=true&"
import script from "./PolicyDetail.vue?vue&type=script&lang=js&"
export * from "./PolicyDetail.vue?vue&type=script&lang=js&"
import style0 from "./PolicyDetail.vue?vue&type=style&index=0&id=271355f4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "271355f4",
  null
  
)

export default component.exports